import { getRequestEvent } from 'solid-js/web';

import { createResolvedStore } from './globalStore';

/** 该渲染的环境变量
 * 这些变量会被服务端和客户端同时渲染，
 * 在服务端的时候需要区分变量是否与请求有关，有关的将使用Async Local Storage来进行存储
 * 比如语言
 *
 */

function getServerEnv(): ENV {
  'use server';
  if (!import.meta.env.SSR) throw new Error('Server only!!!');
  const { locals, nativeEvent, request } = getRequestEvent()!;
  if (!locals.__env) {
    const url = nativeEvent.web?.url!;
    const host = request.headers.get('x-forwarded-host') || url.host;
    const protocol = request.headers.get('x-forwarded-proto') || url.protocol.slice(0, -1);
    const ip = request.headers.get('x-forwarded-for') || '0.0.0.0';
    const city = request.headers.get('x-open-next-city') || '';

    locals.__env = {
      origin: `${protocol}://${host}`,
      host,
      ip,
      city,
    };
  }
  return locals.__env as ENV;
}

function getEnv() {
  return import.meta.env.SSR ? getServerEnv() : ({} as ENV);
}

/** 该资源仅在服务端加载 */
export const [env, mountEnv] = createResolvedStore(getEnv);

interface ENV {
  /** 协议+域名 */
  origin: string;
  /** 域名 */
  host: string;
  /** ip */
  ip: string;
  /** 城市 */
  city: string;
}
